<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-academy.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              Philanthropic
            </h1>
            <div class="intro">We are supporting many endeavors that ring true to us related to education, mental health, and inclusivity.</div>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <p>We launched <a href="http://ASSteroids.NFDaddys.com" target="_blank">ASSteroids</a>, the first ever NFT project that donates 100% of the proceeds to a non-profit agency!</p>
      <p>We have also helped launch <a href="https://inksocietynft.com/" target="_blank">Street Toons</a>, a project that donates 20% of sales to <a href="https://www.4kids.us/" target="_blank">4Kids</a></p>
      <p>If you are interested in learning more or getting your initiative to be considered, please  <a href="/team/contact">reach out here</a>.</p>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "Philanthropic",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>


</style>